/**
 * Lower-cases a trade name for use mid-sentence while keeping acronyms intact:
 * "HVAC & Heating" -> "HVAC & heating", "Painters & Decorators" -> "painters & decorators".
 */
export function tradePhrase(name: string): string {
  return name
    .split(" ")
    .map((word) => (word.length > 1 && word === word.toUpperCase() ? word : word.toLowerCase()))
    .join(" ");
}

const VOWEL_SOUND_LETTERS = new Set(["A", "E", "F", "H", "I", "L", "M", "N", "O", "R", "S", "X"]);

/** Adds "a" or "an" in front of a phrase: "an electrician", "an HVAC & heating", "a roofer". */
export function withArticle(phrase: string): string {
  const firstWord = phrase.split(" ")[0] ?? "";
  const isAcronym = firstWord.length > 1 && firstWord === firstWord.toUpperCase();
  const first = firstWord.charAt(0);
  const useAn = isAcronym ? VOWEL_SOUND_LETTERS.has(first.toUpperCase()) : /[aeiou]/i.test(first);
  return `${useAn ? "an" : "a"} ${phrase}`;
}
